import { Component, OnInit } from '@angular/core';
declare let $: any;

@Component({
  selector: 'app-accommodation',
  templateUrl: './accommodation.component.html',
  styleUrls: ['./accommodation.component.scss']
})
export class AccommodationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  upload_Accommodation_doc():void
  {
    $("#Accommodation_doc").modal('show');
  }


}
